import { ToDateTimeText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import PageviewIcon from '@material-ui/icons/Pageview';

export const getViewHistoryColumns = (viewDetail) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <PageviewIcon
              color="action"
              onClick={() => {
                viewDetail(row.LOAD_ID);
              }}
            />
          </Box>
        );
      },
      
    },
    {
      dataField: "LOAD_ID",
      text: "Load ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "LOAD_TOPIC",
      text: "Load Topic",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ENCRYPT_STATUS",
      text: "Status",
      formatter: (cell, row) => {
        return <>{(row.ENCRYPT_STATUS === "SUCCESS" || row.ENCRYPT_STATUS === "Error" || row.ENCRYPT_STATUS === "FAILED" ) ?  (row.ENCRYPT_STATUS === "FAILED") ? "Error": row.ENCRYPT_STATUS : (row.LOAD_STATUS === "Error") ? "Error" :"Running"}</>;
      },
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Message",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <>{row.ERROR_MESSAGE?.substr(0, 100)}{row.ERROR_MESSAGE?.length > 100 ? "..." : ""}</>;
      },
      headerAlign: 'center',
    },
    {
      dataField: "TARGET_TABLE",
      text: "Target Table",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: '200px' };
      },
      headerAlign: 'center',
    },
    {
        dataField: "LOAD_DATE_TIME_START",
        text: "Upload Start",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: '150px' , textAlign: 'center' };
        },
        formatter: (cell, row, rowIndex) => {
            return <>{ToDateTimeText(row.LOAD_DATE_TIME_START)}</>;
        },
        headerAlign: 'center',
        align: 'center',
      },
      {
        dataField: "LOAD_DATE_TIME_END",
        text: "Upload End",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: '150px', textAlign: 'center' };
        },
        formatter: (cell, row, rowIndex) => {
            return <>{ToDateTimeText(row.LOAD_DATE_TIME_END)}</>;
        },
        headerAlign: 'center',
        align: 'center',
      },
      {
        dataField: "FILE_NAME",
        text: "File Name",
        sort: true,
        headerAlign: 'center',
      },
      {
        dataField: "TOTAL_RECORD",
        text: "Total Record",
        sort: true,
        headerAlign: 'center',
        align: 'center',
      },
      {
        dataField: "USER_NAME",
        text: "Create By",
        sort: true,
        headerAlign: 'center',
        align: 'center',
      },
      // {
      //   dataField: "CREATED_DATE",
      //   text: "Create Date",
      //   sort: true,
      //   formatter: (cell, row, rowIndex) => {
      //       return <>{ToDateTimeText(row.CREATED_DATE)}</>;
      //   },
      // },
  ];
  return columns;
};
export const getDetailUpload = () => {
  const columns = [
    {
      dataField: "ColumnName",
      text: "Column Name",
      sort: true,
    },
    {
      dataField: "Encrypt",
      text: "Encrypt Type",
      sort: true,
    },
   
  ];
  return columns;
};
